import { render, staticRenderFns } from "./LaneClosureRequestChat.vue?vue&type=template&id=4c5299a0&"
import script from "./LaneClosureRequestChat.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports